
export default {
  name: 'SpecialistGeneralistCta'
}
